import { Button, ChevronIcon } from '@higo/ui';
// import { FormattedMessage } from 'react-intl';
import { MouseEvent, useCallback } from 'react';
import styled from 'styled-components';
import { useUserPermissions } from 'hooks/useUserPermissions';
import { useAssignVisitMutation } from 'hooks/mutations/assignExamination';
import { ExaminationQueryKey } from '@higo/common/lib/features/ExaminationPage/ExaminationQueryKey';
import { useQueryClient } from 'react-query';

export type AssignFromVisitPageButtonProps = {
  visitId: number;
  shouldBeInvisible?: boolean;
  onAssigned?: () => void | Promise<void>;
};

export const AssignFromVisitPageButton = ({
  visitId,
  shouldBeInvisible,
  onAssigned,
}: AssignFromVisitPageButtonProps) => {
  const { visitAssignmentPermission } = useUserPermissions();
  const isDiagnosticCreatePermission = visitAssignmentPermission?.create;
  const isAssignExamCreatePermission = visitAssignmentPermission?.create;

  const StyledButton = styled(Button)`
    height: 70px;
    margin: 50px auto;
  `;
  const queryClient = useQueryClient();

  const { mutateAsync } = useAssignVisitMutation(visitId);

  const handleClick = useCallback(
    async (e: MouseEvent) => {
      e.stopPropagation();
      await mutateAsync([visitId]);
      await queryClient.invalidateQueries([
        ExaminationQueryKey.ExaminationDetails,
        visitId,
      ]);
      await onAssigned?.();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visitId, mutateAsync, queryClient, onAssigned],
  );

  return !shouldBeInvisible && isAssignExamCreatePermission && isDiagnosticCreatePermission ? (
    <StyledButton
      onClick={handleClick}
      size="small"
      endIcon={<ChevronIcon direction="right" />}
      id="assign-from-exam-page-button"
      disabled={false}
      color="secondary"
    >
      {/* <FormattedMessage id="common.reviewNow" /> */}
      Assign now
    </StyledButton>
  ) : null;
};
